var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80407 7.80407L3.5 2.5L2.5 3.5L4.90465 5.90465C2.85027 7.66177 2 10 2 10C2 10 4.18182 16 10 16C11.5641 16 12.8655 15.5664 13.9322 14.9322L16.5 17.5L17.5 16.5L12.1959 11.1959C12.3898 10.8407 12.5 10.4332 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C9.56679 7.5 9.15931 7.61019 8.80407 7.80407ZM7.80407 8.80407L6.71586 7.71586C6.26461 8.36347 6 9.15083 6 10C6 12.2091 7.79086 14 10 14C10.8492 14 11.6365 13.7354 12.2841 13.2841L11.1959 12.1959C10.8407 12.3898 10.4332 12.5 10 12.5C8.61929 12.5 7.5 11.3807 7.5 10C7.5 9.56679 7.61019 9.15931 7.80407 8.80407ZM13.8987 10.8987C13.965 10.6098 14 10.309 14 10C14 7.79086 12.2091 6 10 6C9.69101 6 9.39021 6.03503 9.10135 6.10135L7.42944 4.42944C8.19316 4.16068 9.04789 4 10 4C15.8182 4 18 10 18 10C18 10 17.4306 11.5659 16.0978 13.0978L13.8987 10.8987Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHide);
export default __webpack_public_path__ + "static/media/icon-hide.c13d441b4ff3e5650f1a80a04a7d6166.svg";
export { ForwardRef as ReactComponent };